module.exports = __webpack_public_path__ + "img/nicard-logo-part-3.4766458e.png";